export default "__VITE_PUBLIC_ASSET__041a6891__"